import React from 'react'

const AddMasterAdmin = () => {
  return (
    <div>AddMasterAdmin</div>
  )
}

export default AddMasterAdmin